export default "__VITE_ASSET__DsA_dIQT__"